module.exports = __webpack_public_path__ + "static/media/camera.66aaf5eb.svg";